import { render, staticRenderFns } from "./SaudacoesComponent.vue?vue&type=template&id=c55a9628&scoped=true&"
import script from "./SaudacoesComponent.vue?vue&type=script&lang=js&"
export * from "./SaudacoesComponent.vue?vue&type=script&lang=js&"
import style0 from "./SaudacoesComponent.vue?vue&type=style&index=0&id=c55a9628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55a9628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
